// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const poltchageist: PokeData = {
  "id": 1012,
  "name": "poltchageist",
  "height": 1,
  "weight": 11,
  "base_experience": 62,
  "types": [
    PokeType.GRASS,
    PokeType.GHOST
  ],
  "api_moves": [
    "absorb",
    "mega-drain",
    "stun-spore",
    "withdraw",
    "giga-drain",
    "shadow-ball",
    "memento",
    "astonish",
    "leaf-storm",
    "rage-powder",
    "foul-play",
    "hex",
    "life-dew"
  ],
  "moves": [
    "stun-spore",
    "shadow-ball",
    "life-dew",
    "overgrowth",
    "curse",
    "energy-ball",
    "confuse-ray",
    "razor-leaf",
    "spectral-chain",
    "lick",
    "poltergeist",
    "branch-poke",
    "power-whip"
  ],
  "evolution_chain": {
    "id": 539,
    "item": null,
    "species": [
      {
        "name": "poltchageist",
        "order": 1014,
        "types": [
          PokeType.GRASS,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sinistcha",
        "order": 1015,
        "types": [
          PokeType.GRASS,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 1012,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 44.75,
    "speed": 50,
    "ability_power": 74
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
